import axios from 'axios';
import { Message } from 'element-ui';
import { Loading } from 'element-ui';
import router from '../router/index'
// function startLoading() {
//     loading = Loading.service({
//         lock: true,
//         text: '加载中...',
//         background: 'rgba(0, 0, 0, 0.1)'
//     })
// }
// function endLoading() {
//     loading.close()
// }
// let needLoadingRequestCount = 0
// export function showFullScreenLoading() {
//     if (needLoadingRequestCount === 0) {
//         startLoading()
//     }
//     needLoadingRequestCount++
// }
// export function tryHideFullScreenLoading() {
//     if (needLoadingRequestCount <= 0) return
//     needLoadingRequestCount--
//     if (needLoadingRequestCount === 0) {
//         endLoading()
//     }
// }
// 请求超时时间
axios.defaults.timeout = 30000;
// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 请求拦截器
axios.interceptors.request.use(
	config => {
		if(localStorage.getItem('token')) {
			const token = localStorage.getItem('token');
			config.headers['X-Access-Token'] = token;
		}
		// 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
		// 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
		// if (store.state.token) {
		//     const token = store.state.token
		//     // const token = localStorage.getItem('token');
		//     config.headers.token = token;
		// }
		// showFullScreenLoading();
		return config;
	},
	error => {
		return Promise.error(error);
	}
);
// 响应拦截器
axios.interceptors.response.use(
	response => {
		
		// tryHideFullScreenLoading()
		if(response.data.code == '200') {
			return Promise.resolve(response);
		} else if(response.data.code == '500') {
			console.log(8585851)
			return Promise.resolve(response);
//			Message(response.data.message)
		} else {
//			response.data.message?Message(response.data.message):'';
			return Promise.resolve(response);
		}
	},
	error => {
		// tryHideFullScreenLoading()
		if(error && error.response) {
			if(error.response.status == '401') {
				// Message('token失效请重新登录')
			}
		}
	}
);
/**
 * get方法，对应get请求
 */
const get = (url, params) => {
	//	 if (localStorage.getItem('token')) {
	//	 	console.log(params)
	//          const token = localStorage.getItem('token');
	//          params['X-Access-Token'] = token;
	//      }
	return new Promise((resolve, reject) => {
		axios.get(url, {
			params: params
		}).then(res => {
			resolve(res.data);
		}).catch(err => {
			reject(err)
		})
	});
}

/**
 * post方法，对应post请求
 */
const post = (url, params = {}) => {
	return new Promise((resolve, reject) => {
		axios.post(url, params)
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err)
			})
	});
}
/**
 * delete方法，对应delete请求
 */
const deleteUrl = (url, params) => {
	return new Promise((resolve, reject) => {
		axios.delete(url, {
				params: params
			})
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err)
			})
	});
}
/**
 * put方法，对应put请求
 */
const put = (url, params) => {
	return new Promise((resolve, reject) => {
		axios.put(url, params)
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err)
			})
	});
}
const postJson = (url, params) => {
	return new Promise((resolve, reject) => {
		axios.post(url, params, {
				headers: {
					'Content-Type': 'application/json'
				}
			}).then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err)
			})
	});
}
const postUrl = (url, params) => {
	return new Promise((resolve, reject) => {
		axios.post(url, params, {
				headers: {
					//              'Content-Type': 'multipart/form-data'
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			}).then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err)
			})
	});
}

export {
	get,
	post,
	put,
	deleteUrl,
	postUrl,
	postJson
}


// WEBPACK FOOTER //
// ./src/api/index.js